import 'ag-grid-enterprise/dist/styles/ag-grid.css';
import 'ag-grid-enterprise/dist/styles/ag-theme-material.css';
import 'ag-grid-enterprise';
import './PositionsRenderer.scss';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import {
  moneyFormatter,
  quantityFormatter,
  percentFormatter,
  emptyFormatter
} from 'services/TableUtils';

class PositionsRenderer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnDefs: [
        { field: 'name', hide: true, sort: 'asc' },
        { field: 'quantity', valueFormatter: quantityFormatter },
        { field: 'price', valueFormatter: moneyFormatter },
        { field: 'priceChange', valueFormatter: moneyFormatter },
        { field: 'currentBalance', valueFormatter: moneyFormatter },
        { field: 'difference', valueFormatter: moneyFormatter },
        { field: 'priceChangePercent', valueFormatter: percentFormatter },
        { field: 'performance', valueFormatter: emptyFormatter }
      ],
      mobileColumnDefs: [
        {
          field: 'name',
          minWidth: 224,
          width: 224,
          maxWidth: 224,
          sort: 'asc',
          cellClass: 'positions-name'
        },
        {
          field: 'quantity',
          valueFormatter: quantityFormatter,
          cellClass: 'positions-value'
        },
        {
          field: 'price',
          valueFormatter: moneyFormatter,
          cellClass: 'positions-value'
        },
        {
          field: 'priceChange',
          valueFormatter: moneyFormatter,
          cellClass: 'positions-value'
        },
        {
          field: 'currentBalance',
          valueFormatter: moneyFormatter,
          cellClass: 'positions-value'
        },
        {
          field: 'difference',
          valueFormatter: moneyFormatter,
          cellClass: 'positions-value'
        },
        {
          field: 'priceChangePercent',
          valueFormatter: percentFormatter,
          cellClass: 'positions-value'
        },
        {
          field: 'performance',
          valueFormatter: emptyFormatter,
          cellClass: 'positions-value'
        }
      ],
      pinnedColDef: [
        {
          field: 'name',
          minWidth: 370,
          width: 370,
          maxWidth: 370,
          pinned: 'left',
          cellClass: 'ag-pinned-left-cols-container',
          suppressSizeToFit: true,
          sort: 'asc'
        }
      ],
      defaultColDef: {
        suppressMenu: true,
        animateRows: true,
        minWidth: 170,
        maxWidth: 170,
        aggFunc: 'sum',
        cellClass: 'positions-value'
      }
    };
    this.state.rowId = props.node.id;
    this.state.masterGridApi = props.api;
  }

  onGridReady = ({ api, columnApi }) => {
    const gridInfo = {
      id: this.state.rowId,
      api: api,
      columnApi: columnApi
    };

    this.state.masterGridApi.addDetailGridInfo(this.state.rowId, gridInfo);
    this.gridApi = api;
  };

  onFirstDataRendered = () => {
    this.gridApi.sizeColumnsToFit();
  };

  postSort = (rowNodes) => {
    let nextInsertPos = rowNodes.length;
    rowNodes.forEach((node, i) => {
      // Move Cash row node to bottom of grid
      if (node.data && node.data.name === 'Cash') {
        rowNodes
          .splice(nextInsertPos, 0, rowNodes.splice(i, 1)[0])
          .splice(i, 1);
      }
    });
  };

  render() {
    const { pinned, isDesktopLayout } = this.props;

    const columnDefs = pinned
      ? this.state.pinnedColDef
      : isDesktopLayout
      ? this.state.columnDefs
      : this.state.mobileColumnDefs;

    return (
      <div className="ag-theme-material positions">
        <AgGridReact
          columnDefs={columnDefs}
          defaultColDef={this.state.defaultColDef}
          rowData={this.props.data.positions}
          onGridReady={this.onGridReady}
          onFirstDataRendered={this.onFirstDataRendered}
          domLayout="autoHeight"
          headerHeight={0}
          immutableData
          suppressHorizontalScroll
          suppressCellSelection
          postSort={this.postSort}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout
});

export default connect(mapStateToProps)(PositionsRenderer);
